import React, { useContext, useState, useEffect, useRef } from "react";
import { Button, Modal, Space, Spin, Table, Tooltip } from "antd";
import { ImageView } from "../Pages/image/imageView";
import { LanguageContext } from "../context/LanguageContext";
import { ViewGunaDetails } from "../Pages/viewGunaDetails/viewGunaDetails";
import { connect } from "react-redux";
import { professionalAction } from "../_actions";
import moment from "moment";
import { ViewPrevetiveDetails } from "../Pages/viewPreventive/viewPreventive";

const FilterData = (props) => {
  console.log("props filter", props);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(props?.criminalRecords.length);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [name, setName] = useState();
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [preventiveLoading, setPreventiveLoading] = useState(false);
  const [preventiveAction, setPreventiveAction] = useState([]);
  const { t } = useContext(LanguageContext);

  const handleEditForm = (id) => {
    props.handleEditForm(id);
  };
  const handlePreventiveViewForm = (id) => {
    props.handlePreventiveViewForm(id);
  };
  const getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };

  useEffect(() => {
    getPreventiveInfo();
  }, []);

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
    showGunaViewModel();
    if (data) {
      setGunaLoading(true);
      props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  const openImageModal = (img, name) => {
    setImageOpen(true);
    setSelectedImage(img);
    setName(name);
  };

  const [showPreventiveDetails, setShowPreventiveDetails] = useState(false);
  const showpreventiveViewModel = () => {
    setShowPreventiveDetails(true);
  };
  const closepreventiveViewModel = () => {
    setShowPreventiveDetails(false);
  };
  const onpreventiveForm = (data) => {
    showpreventiveViewModel();
    if (data) {
      setPreventiveLoading(true);
      props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      preventiveLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setPreventiveLoading(false);
    }
  }, [props.professionals?.criminalViewList]);
  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
    setName(null);
  };
  const handleViewForm = (data) => {
    props.onViewAccusedDetails(data);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page - 1);
    setPageSize(size);
  };
  console.log("props filter", props);
  let columns = [
    {
      title: t("sr.no"),
      key: "index",
      render: (_, __, index) => currentPage * pageSize + index + 1,
    },
    {
      title: t("name"),
      key: "name",
      render: (text, record) => (
        <Space size="middle" title={record.id} style={{ maxWidth: 300 }}>
          {record.name}
        </Space>
      ),
    },
    {
      title: t("address"),
      key: "address",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.address ? record.address : ""}
        </Space>
      ),
    },
    {
      title: t("age"),
      key: "age",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.age}
        </Space>
      ),
    },
    {
      title: t("phone_no"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.mobileNumber}
        </Space>
      ),
    },
    {
      title: t("accused_police_station"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.districtName}
        </Space>
      ),
    },
    {
      title: t("total_crimes"),
      key: "gunhaCount",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              onGunaForm(record.id);
            }}
          >
            {record.gunhaCount || record.totalCrimeCount || "-"}
          </Button>
        </div>
      ),
    },
    {
      title: t("preventive_action"),
      key: "preventive_recordss",
      filters: [
        { text: t("completed"), value: "completed" },
        { text: t("ongoing"), value: "ongoing" },
        { text: "-", value: "-" },
      ],
      onFilter: (value, record) => {
        const currentDate = moment();

        if (
          !record.preventive_records ||
          record.preventive_records.length === 0
        ) {
          return value === "-";
        }

        const firstRecord = record.preventive_records[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        const status = firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? "completed"
            : "ongoing"
          : "-";

        return status === value;
      },
      sorter: (a, b) => {
        const currentDate = moment();

        const getStatus = (record) => {
          if (
            !record.preventive_records ||
            record.preventive_records.length === 0
          ) {
            return "-";
          }

          const firstRecord = record.preventive_records[0];
          const dateTo = firstRecord.date_to
            ? moment(firstRecord.date_to)
            : null;

          return firstRecord.date_to
            ? dateTo.isBefore(currentDate, "day")
              ? "completed"
              : "ongoing"
            : "-";
        };

        const statusA = getStatus(a);
        const statusB = getStatus(b);

        // sorting order: completed -> ongoing -> "-"
        const order = { completed: 0, ongoing: 1, "-": 2 };

        return order[statusA] - order[statusB];
      },
      render: (text, record) => {
        const currentDate = moment();

        if (
          !record.preventive_records ||
          record.preventive_records.length === 0
        ) {
          return <div className="action-links-responsive">-</div>;
        }

        const firstRecord = record.preventive_records[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        const status = firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? t("completed")
            : t("ongoing")
          : "-";

        return (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              disabled={status === "-"}
              onClick={() => onpreventiveForm(record.id)}
            >
              {status}
            </Button>
          </div>
        );
      },
    },
    {
      title: t("photo"),
      key: "photo",
      render: (text, record) => {
        return (
          <Space size="middle">
            {(record.photo &&
              record.photo.length > 0 &&
              record.photo[0].trim() !== "") ||
            record?.photo_status == "yes" ? (
              <img
                style={{ width: 50, height: 50 }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo[0]
                }
                onClick={() => openImageModal(record.photo[0], record.name)}
              ></img>
            ) : (
              t("no")
            )}
          </Space>
        );
      },
    },
    {
      title: t("action"),
      key: "action",
      render: (text, record) => (
        console.log("record", record),
        (
          <div className="action-links-responsive">
            {props?.search_type && (
              <Button
                type="text"
                size="small"
                className="action-link update-link"
                onClick={() => handleEditForm(record)}
              >
                {t("update")}
              </Button>
            )}

            <Space size="middle">
              <a
                onClick={() => {
                  handleViewForm(record.id);
                }}
              >
                View
              </a>
            </Space>
            {props?.search_type && (
              <Button
                type="text"
                size="small"
                className="action-link update-link"
                onClick={() => handlePreventiveViewForm(record.id)}
              >
                {t("preventive")}
              </Button>
            )}
          </div>
        )
      ),
    },
  ];

  // Find the index of the "action" column
  const actionColIndex = columns.findIndex((col) => col.key === "photo");

  if ((props?.selectedFilter !== "" || props.is_year) && !props?.photo_status) {
    const headingNamesCol = {
      title:
        props?.selectedFilter === "लघु शीर्षक" ||
        props?.selectedFilter === "मोडस"
          ? t("sub_title")
          : t("title"),
      key: "headingNames",
      render: (text, record) => {
        const values =
          props?.selectedFilter === "मोडस"
            ? record?.subheadings
            :  props?.selectedFilter === "लघु शीर्षक" ? record?.subheadings : record?.crime_titles || [];
        const displayValue =
          Array.isArray(values) && values.length > 0 ? values[0] : "";
        const fullValue =
          Array.isArray(values) && values.length > 0 ? values.join(", ") : "";

        return (
          <Tooltip title={fullValue}>
            <Space
              size="middle"
              style={{
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {displayValue}
            </Space>
          </Tooltip>
        );
      },
    };

    columns.splice(actionColIndex, 0, headingNamesCol);
  }

  // Conditionally add the year column before "action"
  if (props.is_year) {
    const yearCol = {
      title: t("crime_register_year"),
      key: "year",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {moment(record.registernumberYear).format("YYYY")}
        </Space>
      ),
    };
    columns.splice(actionColIndex, 0, yearCol);
  }

  console.log("props?.loading", props?.loading);
  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);
  return (
    <>
      <Spin spinning={props.loading}>
        <Table
          columns={columns}
          dataSource={props?.criminalRecords}
          loading={props?.loading}
          pagination={{
            current: currentPage + 1,
            pageSize: pageSize,
            total: total || 0,
            onChange: handlePageChange,
          }}
          rowKey={(record) => record.id || record.key}
        />
      </Spin>

      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          name={name}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
        />
      )}
      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={props.professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(props?.professionals?.criminalViewList?.gunhaInfor) &&
            props?.professionals?.criminalViewList?.gunhaInfor.length > 0
              ? props?.professionals?.criminalViewList?.gunhaInfor
              : []
          }
          name={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          user_details={props?.user}
          masterId={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props?.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
          loading={gunaLoading}
        ></ViewGunaDetails>
      </Modal>
      <Modal
        title={t("preventive_action")}
        top
        visible={showPreventiveDetails}
        onOk={closepreventiveViewModel}
        onCancel={closepreventiveViewModel}
        width={95 + "%"}
      >
        <ViewPrevetiveDetails
          preventiveAction={preventiveAction}
          dataStates={
            Array.isArray(
              props.professionals?.criminalViewList?.preventiveInfo
            ) &&
            props.professionals?.criminalViewList?.preventiveInfo.length > 0
              ? props.professionals?.criminalViewList?.preventiveInfo
              : []
          }
          name={
            Array.isArray(props.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={preventiveLoading}
        ></ViewPrevetiveDetails>
      </Modal>
    </>
  );
};

export default connect()(FilterData);
